import { Tooltip } from 'antd';
import CustomTable from '../../../../components/CustomTable';
import { Upload2 } from '../../../../components/Svg/Svg';
import Markdown from 'markdown-to-jsx';

export default function CoachMeTable({
    data,
    coachMeStatus,
    onCoachMeTableUpload,
}) {
    const cutString = (string) => {
        if (string?.length < 300) return string;

        return string?.slice(0, 300) + '...';
    };

    const createCellWithTooltip = (header, field) => {
        return {
            title: header,
            render: (_, record) => {
                if (!record[field]) return <span>-</span>;
                if (record[field].length < 300)
                    return <span>{record[field]}</span>;

                return (
                    <Tooltip
                        placement="right"
                        title={<Markdown>{record[field]}</Markdown>}
                    >
                        <span>{cutString(record[field])}</span>
                    </Tooltip>
                );
            },
        };
    };

    return (
        <div className="table-wrapper">
            <CustomTable
                className="coach-me-table"
                tablePannelTitle="CoachMe table"
                tableHeader={[
                    'Message ID',
                    'Supplier',
                    'Source',
                    'Section SV',
                    'Section EN',
                    'Section FI',
                    'Section DA',
                    'Alarm',
                    'RegExp Done = 1',
                    'Regexp',
                    'Original text from source',
                    'Message [Push] SV',
                    'Message [Push] EN',
                    'Message [Push] FI',
                    'Message [Push] DA',
                    'Message [Push] NO',
                    'Length SMS',
                    'Description [APP/WEB] SV',
                    'Description [APP/WEB] EN',
                    'Description [APP/WEB] FI',
                    'Description [APP/WEB] DA',
                    'Description [APP/WEB] NO',
                    'Guide [Hepl Center] SV',
                    'Guide [Hepl Center] EN',
                    'Guide [Hepl Center] FI',
                    'Guide [Hepl Center] DA',
                    'Guide [Hepl Center] NO',
                    'Severity',
                    'Country codes',
                ]}
                columnsDataMap={{
                    'RegExp Done = 1': 'regexp_done',
                    'Message [Push] SV': 'message_push_sv',
                    'Message [Push] EN': 'message_push_en',
                    'Message [Push] FI': 'message_push_fi',
                    'Message [Push] DA': 'message_push_da',
                    'Message [Push] NO': 'message_push_no',
                    'Description [APP/WEB] SV': 'description_app_web_sv',
                    'Description [APP/WEB] EN': 'description_app_web_en',
                    'Description [APP/WEB] FI': 'description_app_web_fi',
                    'Description [APP/WEB] DA': 'description_app_web_da',
                    'Description [APP/WEB] NO': 'description_app_web_no',
                    'Guide [Hepl Center] SV': 'guide_sv',
                    'Guide [Hepl Center] EN': 'guide_en',
                    'Guide [Hepl Center] FI': 'guide_fi',
                    'Guide [Hepl Center] DA': 'guide_da',
                    'Guide [Hepl Center] NO': 'guide_no',
                }}
                functionalCell={{
                    'Message [Push] SV': createCellWithTooltip(
                        'Message [Push] SV',
                        'message_push_sv',
                    ),
                    'Message [Push] EN': createCellWithTooltip(
                        'Message [Push] EN',
                        'message_push_en',
                    ),
                    'Message [Push] FI': createCellWithTooltip(
                        'Message [Push] FI',
                        'message_push_fi',
                    ),
                    'Message [Push] DA': createCellWithTooltip(
                        'Message [Push] DA',
                        'message_push_da',
                    ),
                    'Message [Push] NO': createCellWithTooltip(
                        'Message [Push] NO',
                        'message_push_no',
                    ),
                    'Description [APP/WEB] SV': createCellWithTooltip(
                        'Description [APP/WEB] SV',
                        'description_app_web_sv',
                    ),
                    'Description [APP/WEB] EN': createCellWithTooltip(
                        'Description [APP/WEB] EN',
                        'description_app_web_en',
                    ),
                    'Description [APP/WEB] FI': createCellWithTooltip(
                        'Description [APP/WEB] FI',
                        'description_app_web_fi',
                    ),
                    'Description [APP/WEB] DA': createCellWithTooltip(
                        'Description [APP/WEB] DA',
                        'description_app_web_da',
                    ),
                    'Description [APP/WEB] NO': createCellWithTooltip(
                        'Description [APP/WEB] NO',
                        'description_app_web_no',
                    ),
                    'Guide [Hepl Center] SV': createCellWithTooltip(
                        'Guide [Hepl Center] SV',
                        'guide_sv',
                    ),
                    'Guide [Hepl Center] EN': createCellWithTooltip(
                        'Guide [Hepl Center] EN',
                        'guide_en',
                    ),
                    'Guide [Hepl Center] FI': createCellWithTooltip(
                        'Guide [Hepl Center] FI',
                        'guide_fi',
                    ),
                    'Guide [Hepl Center] DA': createCellWithTooltip(
                        'Guide [Hepl Center] DA',
                        'guide_da',
                    ),
                    'Guide [Hepl Center] NO': createCellWithTooltip(
                        'Guide [Hepl Center] NO',
                        'guide_no',
                    ),
                }}
                searchInputPlaceholder="Search"
                topPannelButtonText={
                    <div className="table-top-pannel__button--with-icon">
                        <Upload2 />
                        <span>Upload table</span>
                    </div>
                }
                isLoading={coachMeStatus === 'loading'}
                data={data}
                onAddButtonClick={onCoachMeTableUpload}
                tableScroll={{ x: 5300, y: 500 }}
            />
        </div>
    );
}
